export default __webpack_public_path__ + "assets/images/c14d407d8d853fdb3f14b8e9ba44f773.svg";